import type { TokenResponse } from 'expo-auth-session';

import { TOKEN_EXPIRED_LEAD_TIME } from '@/features/authorization/constants/token';
import { useAuthStore } from '@/features/authorization/store/useAuthStore';

/**
 * Calculates the expire time of the token
 *
 * @param tokenResponse
 * @returns Returns the expire time of the token as timestamp in milliseconds
 */
export const getTokenExpireTimestamp = (tokenResponse: TokenResponse): number =>
  (tokenResponse.issuedAt + (tokenResponse.expiresIn ?? 0)) * 1000;

/**
 * Checks if token expiration time (issuedAt + expiresIn) is in the past with 10 seconds offset
 * @returns true if token is expired
 */
export const getIsTokenExpired = (): boolean => {
  const storedToken = useAuthStore.getState().token;

  if (!storedToken) {
    return true;
  }

  const expirationTimestamp =
    getTokenExpireTimestamp(storedToken) - TOKEN_EXPIRED_LEAD_TIME;

  return Date.now() > expirationTimestamp;
};

/**
 * Calculates the expire time of the token
 *
 * @param tokenResponse
 * @returns Returns the expire time of the token as timestamp in milliseconds
 */
export const getTokenExpireTimeInMinutes = (): number => {
  const storedToken = useAuthStore.getState().token;

  return (storedToken?.expiresIn ?? 0) / 60;
};
